import request from '@/utils/request'


// 查询首页通知列表
export function listHomeNotice(query) {
  return request({
    url: '/user/home-notice/list',
    method: 'get',
    params: query
  })
}

// 查询首页通知分页
export function pageHomeNotice(query) {
  return request({
    url: '/user/home-notice/page',
    method: 'get',
    params: query
  })
}

// 查询首页通知详细
export function getHomeNotice(data) {
  return request({
    url: '/user/home-notice/detail',
    method: 'get',
    params: data
  })
}

// 新增首页通知
export function addHomeNotice(data) {
  return request({
    url: '/user/home-notice/add',
    method: 'post',
    data: data
  })
}

// 修改首页通知
export function updateHomeNotice(data) {
  return request({
    url: '/user/home-notice/edit',
    method: 'post',
    data: data
  })
}

// 删除首页通知
export function delHomeNotice(data) {
  return request({
    url: '/user/home-notice/delete',
    method: 'post',
    data: data
  })
}
